import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useStyles = makeStyles({
    fillParent: {
        width: '100%',
        height: '100%',
    },
    container: {
        display: 'grid',
        gridTemplateRows: '1fr',
        width: '100%',
        borderRadius: tokens.borderRadiusXLarge,
        boxShadow: tokens.shadow2,
        backgroundColor: tokens.colorNeutralBackground1,
        overflow: 'hidden',
        minHeight: 0,
    },
    section: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        paddingBlock: tokens.spacingVerticalL,
        paddingInline: tokens.spacingVerticalXXL,
    },
    header: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minWidth: 0,
        isolation: 'isolate',
    },
    headerStrip: {
        zIndex: 1,
        height: px(4),
        width: '100%',
    },
    headerLabel: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
        minWidth: 0,
        color: tokens.colorNeutralForeground1,
        fontWeight: tokens.fontWeightSemibold,
        textTransform: 'uppercase',
    },
    headerLabelText: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    headerLabelIcon: {
        position: 'relative',
        display: 'flex',
        flexShrink: 0,
        fontSize: px(20),
        aspectRatio: '1 / 1',
    },
    headerActions: {
        display: 'flex',
        flexShrink: 0,
        marginBlock: px(-10),
        gap: tokens.spacingHorizontalS,
    },
});
